import { MemberPaymentDraftForm } from './MemberPaymentDraftForm';
import './member-self-balance.css';
import './member-payment.css';

export function MemberPaymentRegistrationView() {
  return (
    <div className="member-self">
      <header className="member-self__heading">
        <div>
          <span>PORTAL DEL SOCIO</span>
          <h1>Registrar pago</h1>
          <p>Envía tu comprobante para revisión de tesorería o administración.</p>
        </div>
      </header>
      <MemberPaymentDraftForm />
    </div>
  );
}
